export default "__VITE_PUBLIC_ASSET__a3c69f53__"